import { Divider, Stack } from '@mantine/core';
import type { ParticipantAttendanceFhirStatus } from '@/pages/appointments/utils/participantAttendance';
import type { ClientLocationConfirmation } from '@/lib/sessionLocation/types';
import type { ClientLocationConfirmationFormInput } from '@/schemas/client-location-confirmation.schema';
import type { SessionAppointment } from '../data/mockSessionData';
import type { SessionAttendanceEntry } from '../lib/sessionAttendance';
import type { SessionContactInfo } from '../lib/sessionContactInfo';
import { SessionParticipantsSection } from '../components/SessionParticipantsSection';
import { NextAppointmentSidebarSection } from '../components/NextAppointmentSidebarSection';

export interface SessionOverviewTabProps {
  participants: SessionContactInfo[];
  appointment: SessionAppointment;
  initialAttendance: Map<string, ParticipantAttendanceFhirStatus>;
  onSaveAttendance: (entries: SessionAttendanceEntry[]) => Promise<void>;
  onRegisterFlush?: (flush: (() => Promise<void>) | null) => void;
  clientLocationConfirmations?: Record<string, ClientLocationConfirmation>;
  clientLocationLoading?: boolean;
  clientLocationSaving?: boolean;
  clientLocationSaveError?: string | null;
  onSaveClientLocation?: (
    patientId: string,
    values: ClientLocationConfirmationFormInput,
  ) => Promise<void>;
  patientId?: string;
  patientDisplay?: string;
  episodeId?: string;
  appointmentId?: string;
  appointmentStart?: string;
}

export function SessionOverviewTab({
  participants,
  appointment,
  initialAttendance,
  onSaveAttendance,
  onRegisterFlush,
  clientLocationConfirmations = {},
  clientLocationLoading = false,
  clientLocationSaving = false,
  clientLocationSaveError = null,
  onSaveClientLocation,
  patientId,
  patientDisplay,
  episodeId,
  appointmentId,
  appointmentStart,
}: SessionOverviewTabProps): JSX.Element {
  return (
    <Stack gap="md">
      <SessionParticipantsSection
        participants={participants}
        appointment={appointment}
        initialAttendance={initialAttendance}
        onSaveAttendance={onSaveAttendance}
        onRegisterFlush={onRegisterFlush}
        clientLocationConfirmations={clientLocationConfirmations}
        clientLocationLoading={clientLocationLoading}
        clientLocationSaving={clientLocationSaving}
        clientLocationSaveError={clientLocationSaveError}
        onSaveClientLocation={onSaveClientLocation}
      />
      <Divider />
      <NextAppointmentSidebarSection
        patientId={patientId}
        patientDisplay={patientDisplay}
        episodeId={episodeId}
        appointmentId={appointmentId}
        appointmentStart={appointmentStart}
      />
    </Stack>
  );
}
